import { Progress } from "@/components/ui/progress";

interface ATSScoreGaugeProps {
  score: number;
}

export const ATSScoreGauge = ({ score }: ATSScoreGaugeProps) => {
  const getColor = () => {
    if (score >= 90) return "bg-green-600";
    if (score >= 75) return "bg-yellow-600";
    return "bg-red-600";
  };

  return (
    <div className="space-y-4">
      <div className="relative pt-1">
        <div className="flex mb-2 items-center justify-between">
          <div>
            <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-primary-foreground bg-primary">
              ATS Score
            </span>
          </div>
          <div className="text-right">
            <span className="text-xs font-semibold inline-block text-primary">
              {score}%
            </span>
          </div>
        </div>
        <div className="overflow-hidden h-4 mb-4 text-xs flex rounded-full bg-secondary">
          <div
            style={{ width: `${score}%` }}
            className={`shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center ${getColor()} transition-all duration-500`}
          />
        </div>
      </div>
      
      <div className="grid grid-cols-3 gap-2 text-xs text-center">
        <div className={`p-2 rounded ${score < 60 ? 'bg-red-100 dark:bg-red-950' : 'bg-muted'}`}>
          <div className="font-semibold">0-59</div>
          <div className="text-muted-foreground">Needs Work</div>
        </div>
        <div className={`p-2 rounded ${score >= 60 && score < 90 ? 'bg-yellow-100 dark:bg-yellow-950' : 'bg-muted'}`}>
          <div className="font-semibold">60-89</div>
          <div className="text-muted-foreground">Good</div>
        </div>
        <div className={`p-2 rounded ${score >= 90 ? 'bg-green-100 dark:bg-green-950' : 'bg-muted'}`}>
          <div className="font-semibold">90-100</div>
          <div className="text-muted-foreground">Excellent</div>
        </div>
      </div>
    </div>
  );
};
